<template>
  <div class="flex flex-col w-full mb-6">
    <div class="w-full bg-white p-5 rounded shadow-md relative">
      <div class="mt-6">
        <div class="flex items-center">
          <h3 class="uppercase text-lg font-semibold text-primary tracking-wide">Certificate Statement</h3>
          <hr class="flex-grow border-primary ml-4" />

          <div class="flex justify-end ml-2">
            <AppButton v-if="!editMode" color="blue" :icon="true" class="mr-2" @click="enableEdit">
              <template #icon><Icon iconType="edit" /></template>
            </AppButton>
            <AppButton v-if="editMode" color="blue" :icon="true" class="mr-2" @click="saveChanges">
              <template #icon><Icon iconType="save" /></template>
            </AppButton>
            <AppButton v-if="editMode" color="gray" :icon="true" @click="cancelEdit">
              <template #icon><Icon iconType="close" /></template>
            </AppButton>
          </div>
        </div>

        <div v-if="editMode">
          <Editor v-model="editableStatement" editorStyle="height: 120px" :options="editorOptions">
            <template #toolbar>
              <span class="ql-formats">
                <button class="ql-bold"></button>
                <button class="ql-italic"></button>
                <button class="ql-underline"></button>
                <button class="ql-list" value="ordered"></button>
                <button class="ql-list" value="bullet"></button>
              </span>
            </template>
          </Editor>
        </div>

        <div v-else class="bg-gray-100 p-4 rounded-md mt-6">
          <!-- preview from source of truth -->
          <div v-html="form.statement"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AppButton from '@/components/Button.vue';
import Icon from '@/components/Icon.vue';
import notificationMixin from '@/mixins/notificationMixin';

function blankForm() {
  return { statement: '' };
}

export default {
  name: 'StatementOnly',
  mixins: [notificationMixin],
  components: { AppButton, Icon },

  props: {
    calibration_details: {
      type: Object,
      default: function () { return {}; }
    }
  },

  emits: ['update:calibration_details'],

  data() {
    return {
      form: blankForm(),
      editMode: false,
      editableStatement: '',
      hasUserEdited: false,
      editorOptions: {
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline'],
            [{ list: 'ordered' }, { list: 'bullet' }],
          ]
        },
        theme: 'snow'
      }
    };
  },

  mounted() {
    this.seedFrom(this.calibration_details);
  },

  watch: {
    calibration_details: {
      deep: true,
      handler(val) {
        if (!val) return;
        if (this.hasUserEdited) return;
        this.seedFrom(val);
      }
    },

    editableStatement(val) {
      this.form.statement = val || '';
    },

    form: {
      deep: true,
      handler(v) {
        this.hasUserEdited = true;
        this.$emit('update:calibration_details', JSON.parse(JSON.stringify(v)));
      }
    }
  },

  methods: {
    seedFrom(src) {
      var safe = (src && typeof src === 'object') ? src : {};
      this.form = {
        statement: typeof safe.statement !== 'undefined' ? safe.statement : ''
      };
      this.editableStatement = this.form.statement;
      this.hasUserEdited = false;
    },

    getCurrentData() {
      return JSON.parse(JSON.stringify(this.form));
    },

    enableEdit() {
      this.editMode = true;
      this.editableStatement = this.form.statement || '';
    },

    saveChanges() {
      this.editMode = false;
    },

    cancelEdit() {
      this.editMode = false;
      this.editableStatement = this.form.statement || '';
    }
  }
};
</script>
